import { useUser } from '@/components/providers/user-provider';
import { CreateUser } from './CreateUser';
import { ListUser } from './ListUsers';
import { Navigate } from 'react-router-dom';

export function Users() {
  const { role } = useUser();

  if (role !== 'admin' && role !== undefined) {
    <Navigate to='/' replace />;
  }

  return (
    <>
      <CreateUser />
      <ListUser />
    </>
  );
}
